const roleModule = {
  namespaced: true,

  state: {
    searchForm: { role: '' },
    dataList: []
  },
  getters: {
    getSearchForm: (state) => state.searchForm,
    getDataList: (state) => state.dataList
  },
  mutations: {
    setSearchForm(state, formData) {
      state.searchForm = formData
    },
    clearSearchForm(state) {
      state.searchForm = { role: '' }
      state.dataList = []
    },
    setDataList(state, newDataList) {
      state.dataList = newDataList
    }
  },
  actions: {
    search({ commit }) {
      // TODO: API

      const searchResult = Array.from({ length: 10 }).map((_, index) => {
        return {
          // TODO: 待串接資料移除假資料
          id: Math.floor(Math.random() * 900) + 100,
          name:
            index === 0 ? 'Admin' : Math.random() < 0.5 ? '社區管理員' : '保全',
          social:
            index === 0 ? '所有權限' : Math.random() < 0.5 ? '編輯' : '檢視',
          communitydoor:
            index === 0
              ? '所有權限'
              : Math.random() < 0.5
              ? '所有權限'
              : '檢視',
          communityImage:
            index === 0 ? '所有權限' : Math.random() < 0.5 ? '編輯' : '無',
          event:
            index === 0
              ? '所有權限'
              : Math.random() < 0.5
              ? '所有權限'
              : '檢視',
          resident:
            index === 0 ? '所有權限' : Math.random() < 0.5 ? '無' : '檢視',
          license:
            index === 0 ? '所有權限' : Math.random() < 0.5 ? '編輯' : '檢視',
          device:
            index === 0 ? '所有權限' : Math.random() < 0.5 ? '編輯' : '無',
          system:
            index === 0 ? '所有權限' : Math.random() < 0.5 ? '無' : '檢視',
          option: [
            {
              value: '所有權限',
              label: '所有權限'
            },
            {
              value: '檢視',
              label: '檢視'
            },
            {
              value: '編輯',
              label: '編輯'
            },
            {
              value: '無',
              label: '無'
            }
          ],
          disabled: index === 0 ? true : false
        }
      })

      // 更新 dataList
      commit('setDataList', searchResult)
    },
    clearSearch({ commit }) {
      // Clear the search form by calling the clearSearchForm mutation
      commit('clearSearchForm')
    }
  }
}

export default roleModule
